<h1 mat-dialog-title>
  @if (Quote()) {
    <span>Edit Quote {{Quote().QuoteNumber}} - </span>
    @if (!isFromVendor) {
      <a class="vendor-link" (click)="editVendor(Quote().VendorId)">{{Quote().VendorName}} ({{Quote().VendorCode}})</a>
    }
    @if (isFromVendor) {
      <span>{{Quote().VendorName}} ({{Quote().VendorCode}})</span>
    }
  }
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow>
  <form name="quote-create-form" #quoteEditForm="ngForm" style="padding-bottom: 15px;">
    @if (Quote()) {
      <div class="row">
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-7">
                  <ng-container *ngTemplateOutlet="vendorQuoteNumber"></ng-container>
                </div>
                <div class="col-sm-5">
                  <ng-container *ngTemplateOutlet="quoteStatus"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <ng-container *ngTemplateOutlet="comments"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-7">
                  <ng-container *ngTemplateOutlet="prNumber"></ng-container>
                </div>
                <div class="col-sm-5">
                  <ng-container *ngTemplateOutlet="poStart"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-7">
                  <ng-container *ngTemplateOutlet="poNumber"></ng-container>
                </div>
                <div class="col-sm-5">
                  <ng-container *ngTemplateOutlet="poEnd"></ng-container>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-4">
                  <ng-container *ngTemplateOutlet="year"></ng-container>
                </div>
                <div class="col-sm-8">
                  <ng-container *ngTemplateOutlet="contactName"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <ng-container *ngTemplateOutlet="personResponsible"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <ng-container *ngTemplateOutlet="agreementStartDate"></ng-container>
                </div>
                <div class="col-sm-6">
                  <ng-container *ngTemplateOutlet="agreementEndDate"></ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <ng-container *ngTemplateOutlet="poRequired"></ng-container>
                </div>
                <div class="col-sm-6">
                  <ng-container *ngTemplateOutlet="total"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <document-picker (safeToSaveParent)="onSafeToSaveParent($event)" [(documents)]="Quote().Documents"
            [canAdd]="!isDocumentChangeDisabled()" [canRemove]="!isDocumentChangeDisabled()"
            [isAtLeastOneRequired]="IsAtLeastOneDocumentRequired()"></document-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="mat-elevation-z8" style="margin-top: 8px;">
            <div class="data-table-quote">
              <quote-edit-modal-line-item-assoc-grid [isGridDisabled]="isGridDisabled()" [rows]="lineItemRows()"
                [budgetYears]="budgetYears()" [quoteId]="Quote().Id"
                [hasDocs]="checkDocumentStatus()"></quote-edit-modal-line-item-assoc-grid>
            </div>
          </div>
        </div>
      </div>
    }

    <ng-template #vendorQuoteNumber>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Vendor Quote Number</mat-label>
        <input matInput [(ngModel)]="Quote().VendorAssignedQuoteNumber" #vendorQuoteNumber name="vendorQuoteNumber"
          maxlength="255" />
        <mat-hint>&nbsp;</mat-hint>
      </mat-form-field>
    </ng-template>
    <ng-template #quoteStatus>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select panelClass="quote-edit-modal-select-panel" required [(ngModel)]="Quote().Status" #quoteStatus
          name="quoteStatus">
          @for (status of Dropdowns.QuoteStatuses; track status) {
            <mat-option [value]="status.id" [disabled]="!status.isEnabled()">{{status.label}}</mat-option>
          }
        </mat-select>
        <mat-hint>&nbsp;</mat-hint>
      </mat-form-field>
    </ng-template>
    <ng-template #comments>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Comments</mat-label>
        <input matInput [(ngModel)]="Quote().Comments" #comments name="comments" maxlength="255" />
      </mat-form-field>
    </ng-template>
    <ng-template #year>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Year</mat-label>
        <input matInput [(ngModel)]="Quote().Year" name="year" disabled />
      </mat-form-field>
    </ng-template>
    <ng-template #personResponsible>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label matTooltip="Trial/Non-Trial Responsible Person">Trial/Non-Trial Investigator</mat-label>
        <input matInput [(ngModel)]="Quote().FieldScientistName" name="personResponsible" disabled />
      </mat-form-field>
    </ng-template>
    <ng-template #contactName>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Vendor/Contact</mat-label>
        <input matInput [(ngModel)]="Quote().ContactName" name="contact" disabled />
        <mat-hint>{{Quote().ContactEmail ? Quote().ContactEmail : "No Email for this Contact"}}</mat-hint>
      </mat-form-field>
    </ng-template>
    <ng-template #agreementStartDate>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Agreement Start Date</mat-label>
        <input matInput [(ngModel)]="ActiveAgreement.StartDate" name="agreementStart" disabled />
      </mat-form-field>
    </ng-template>
    <ng-template #agreementEndDate>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Agreement End Date</mat-label>
        <input matInput [(ngModel)]="ActiveAgreement.EndDate" name="agreementEnd" disabled />
      </mat-form-field>
    </ng-template>
    <ng-template #poRequired>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>PO Required</mat-label>
        <input matInput [(ngModel)]="PurchaseOrderRequired" name="poRequired" disabled />
      </mat-form-field>
    </ng-template>
    <ng-template #prNumber>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>PR</mat-label>
        <input matInput [(ngModel)]="Quote().PurchaseRequisitionNumber" #pr name="pr" maxlength="255"
          [disabled]="isPurchaseRequisitionDisabled()" />
      </mat-form-field>
    </ng-template>
    <ng-template #poNumber>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>PO</mat-label>
        <input matInput [(ngModel)]="Quote().PurchaseOrderNumber" #po name="po" maxlength="255"
          [disabled]="isPurchaseOrderDisabled()" />
      </mat-form-field>
    </ng-template>
    <ng-template #poStart>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>PO Start</mat-label>
        <input matInput [(ngModel)]="Quote().PurchaseOrderStartDate" #poStart="ngModel"
          [required]="Quote().IsPurchaseOrderRequired" name="poStart" [matDatepicker]="startDate"
          [disabled]="isPurchaseOrderDisabled()" />
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
        @if (poStart.errors?.required) {
        <mat-error>
          Start Date is required
        </mat-error>
        }
      </mat-form-field>
    </ng-template>
    <ng-template #poEnd>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>PO End</mat-label>
        <input matInput [(ngModel)]="Quote().PurchaseOrderEndDate" #poEnd="ngModel"
          [required]="Quote().IsPurchaseOrderRequired" name="poEnd" [matDatepicker]="endDate"
          [min]="Quote().PurchaseOrderStartDate" [disabled]="isPurchaseOrderDisabled()" />
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
        @if (poEnd.errors?.required) {
          <mat-error>
            End Date is required
          </mat-error>
        }
        @if (poEnd.errors?.matDatepickerMin) {
          <mat-error>
            End Date must be after Start Date
          </mat-error>
        }
      </mat-form-field>
    </ng-template>
    <ng-template #total>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Total</mat-label>
        <input matInput name="totalcommited" [disabled]="true" value="{{GetTotalCommitedAmount() | number}}" />
      </mat-form-field>
    </ng-template>
  </form>
</div>

<div mat-dialog-actions style="display: flex">
  @if (Quote()) {
  <dl class="dl-horizontal modal-audit-info">
    @if (Quote().CreatedByName != undefined && Quote().CreatedByPersonId != 0) {
      <dt>Created:</dt>
    }
    @if (Quote().CreatedByName != undefined && Quote().CreatedByPersonId != 0) {
      <dd>{{ Quote().CreatedDate | date:'d-LLL-y' }} by {{ Quote().CreatedByName }}</dd>
    }
    @if (Quote().UpdatedByName != undefined && Quote().UpdatedByPersonId != 0) {
      <dt>Updated:</dt>
    }
    @if (Quote().UpdatedByName != undefined && Quote().UpdatedByPersonId != 0) {
      <dd>{{ Quote().UpdatedDate | date:'d-LLL-y' }} by {{ Quote().UpdatedByName }}</dd>
    }
    @if (Quote().SubmittedByPersonId != undefined && Quote().SubmittedByPersonId != 0) {
      <dt>Submitted:</dt>
    }
    @if (Quote().SubmittedByPersonId != undefined && Quote().SubmittedByPersonId != 0) {
      <dd>{{ Quote().SubmittedDate | date:'d-LLL-y' }} by {{ Quote().SubmittedByPersonName }}</dd>
    }
    @if (Quote().LastApprovedByPersonId != undefined && Quote().LastApprovedByPersonId != 0) {
      <dt>Last Approved:</dt>
    }
    @if (Quote().LastApprovedByPersonId != undefined && Quote().LastApprovedByPersonId != 0) {
      <dd>{{ Quote().LastApprovedDate | date:'d-LLL-y' }} by {{ Quote().LastApprovedByPersonName }}</dd>
    }
  </dl>
  }

  <span style="flex: 1 1 auto;"></span>
  <button mat-raised-button (click)="ExportAriba()">
    <mat-icon>save_alt</mat-icon>Export Ariba Template</button>
  <button mat-raised-button (click)="AddInvoice()" [disabled]="isInvoiceButtonDisabled()">
    <mat-icon>add</mat-icon>Create FSPS Invoice
  </button>
  <button mat-raised-button color="warn" (click)="DeleteQuote()" [disabled]="DisableDelete()">Delete</button>
  <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
  <button mat-raised-button color="primary" (click)="SaveQuote(quoteEditForm)">Save</button>
  <button mat-raised-button color="primary" (click)="SaveQuoteAndClose(quoteEditForm)">Save &amp; Close</button>
</div>
